import React from 'react';

import { twMerge } from 'utilities/src/twMerge';

type ClassesOrSkeletons =
  | {
      classes?: string;
      skeletons?: never;
    }
  | {
      classes?: never;
      skeletons?: React.ReactNode;
    };

export type SkeletonProps = ClassesOrSkeletons & {
  isLoading?: boolean;
  children: React.ReactElement;
  Wrapper?: React.ComponentType<{ children: React.ReactNode }>;
};

const baseClasses =
  "[&_.skeleton]:relative [&_.skeleton]:after:absolute [&_.skeleton]:overflow-hidden [&_.skeleton]:bg-neutrals-200 [&_.skeleton]:after:left-0 [&_.skeleton]:after:right-0 [&_.skeleton]:after:top-0 [&_.skeleton]:after:bottom-0 [&_.skeleton]:after:content-[''] [&_.skeleton]:after:-translate-x-full [&_.skeleton]:after:bg-skeleton-gradient [&_.skeleton]:after:animate-shimmer";

export default function Skeleton({
  isLoading,
  children,
  Wrapper = React.Fragment,
  classes,
  skeletons,
}: SkeletonProps) {
  return isLoading ? (
    <Wrapper>
      <div className={baseClasses}>{skeletons ?? <div className={twMerge('skeleton', classes)} />}</div>
    </Wrapper>
  ) : (
    children
  );
}
